import React, { useState, useEffect } from 'react';

interface RotatingTextProps {
  words: string[];
  interval?: number; // intervallo di rotazione in ms
  className?: string;
}

const RotatingText: React.FC<RotatingTextProps> = ({ 
  words, 
  interval = 2000, // default 2 secondi
  className = ''
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(true);
  const fadeTime = 300; // tempo per le animazioni in ms

  useEffect(() => {
    // Funzione di animazione: fade out -> cambia testo -> fade in
    const rotateWords = () => {
      // Nascondi il testo attuale
      setIsVisible(false);
      
      // Aspetta che l'animazione di fade out sia completata
      setTimeout(() => {
        // Cambia l'indice
        setCurrentIndex(prevIndex => (prevIndex + 1) % words.length);
        
        // Mostra il nuovo testo
        setIsVisible(true);
      }, fadeTime);
    };

    // Imposta il timer per la rotazione
    const timerId = setInterval(rotateWords, interval);
    
    // Pulizia del timer quando il componente viene smontato
    return () => clearInterval(timerId);
  }, [words, interval]);

  return (
    <span 
      className={`${className} transition-opacity duration-${fadeTime} ${isVisible ? 'opacity-100' : 'opacity-0'}`}
    >
      {words[currentIndex]}
    </span>
  );
};

export default RotatingText;
